const normalizeStepId = (value: string | null): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

const normalizeAlias = (value: string): string => {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
};

const STEP_ALIASES: Record<string, string> = {
  checkoutcomplete: "checkout_complete"
};

const resolveStepFromHash = (hash: string): string | null => {
  if (!hash || hash === "#") {
    return null;
  }

  const rawValue = hash.startsWith("#") ? hash.slice(1) : hash;
  let decodedValue = rawValue;
  try {
    decodedValue = decodeURIComponent(rawValue);
  } catch {
    decodedValue = rawValue;
  }

  decodedValue = decodedValue.trim();
  if (!decodedValue) {
    return null;
  }

  const aliasMatch = STEP_ALIASES[normalizeAlias(decodedValue)];
  if (aliasMatch) {
    return aliasMatch;
  }

  return normalizeStepId(decodedValue);
};

const resolveLegacyStepFromSearch = (search: string): string | null => {
  if (!search) {
    return null;
  }

  const searchParams = new URLSearchParams(search);
  return normalizeStepId(searchParams.get("step"));
};

export const resolveStepFromUrl = (
  urlLike: URL | string = window.location.href
): string | null => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;
  return resolveStepFromHash(url.hash) ?? resolveLegacyStepFromSearch(url.search);
};

export const replaceStepInUrl = (stepId: string): void => {
  const normalizedStepId = normalizeStepId(stepId);
  if (!normalizedStepId) {
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete("step");
  url.hash = normalizedStepId;

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (nextUrl === currentUrl) {
    return;
  }

  window.history.replaceState(window.history.state, "", url);
};
